export enum TerminalTypeCode {
    DialUp,
    IP,
    Cellular,
    Virtual
}